// Detection now lives in @solomon-apps/shared (positionSourceDetection.ts),
// shared with the issuer console's Add Position form. Re-exported so existing
// imports keep working.
export { detectionSourceKind, detectPositionSource } from "@solomon-apps/shared";
export type { PositionSourceDetection } from "@solomon-apps/shared";
